import { useContext } from 'react';
import { Box } from '@mui/material';

import { RiskPanelFilters } from './risk-panel-filters';
import { RiskPanelGraph } from './risk-panel-graph';
import { RiskContext } from '../../../../../providers/portfolio-performance/risk';
import { MetricKey } from '../../../../../providers/portfolio-performance/risk/risk.types';
import { formatTokenName } from '../../../../../providers/portfolio-performance/risk/risk.helpers';
import './styles.scss';

// Fixed layout: PV full-width on top, Delta|Theta, Gamma|Vega below.
const LAYOUT: { key: MetricKey; label: string; fullWidth?: boolean; height: number }[] = [
  { key: 'PV', label: 'PV', fullWidth: true, height: 320 },
  { key: 'DELTA', label: 'Delta', height: 260 },
  { key: 'THETA', label: 'Theta', height: 260 },
  { key: 'GAMMA', label: 'Gamma', height: 260 },
  { key: 'VEGA', label: 'Vega', height: 260 },
];

export const RiskPanelCard = () => {
  const { metricsData, selectedToken, loadingMetrics, errorMetrics } = useContext(RiskContext);

  return (
    <div className="pp-graphs">
      <div className="pp-graphs-header">
        <span className="pp-risk-title">Risk</span>
        <RiskPanelFilters />
      </div>

      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
        {LAYOUT.map(({ key, label, fullWidth, height }) => {
          const series = (metricsData[key]?.data ?? []).map(([ts, v]) => ({
            time: ts,
            value: v,
          }));

          return (
            <Box key={key} sx={{ gridColumn: fullWidth ? '1 / -1' : undefined, height }}>
              <RiskPanelGraph
                metric={key}
                label={`${label} - ${formatTokenName(selectedToken)}`}
                series={series as never}
                loading={loadingMetrics[key] ?? false}
                error={errorMetrics[key] ?? false}
              />
            </Box>
          );
        })}
      </Box>
    </div>
  );
};
